import { firebase } from "@firebase/app";
import "@firebase/firestore";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyD5rfsSjRNYFv_T7ArUJuqyVCXHepldn2Y",
  authDomain: "thebonningtobeast.firebaseapp.com",
  databaseURL: "https://thebonningtobeast.firebaseio.com",
  projectId: "thebonningtobeast",
  storageBucket: "thebonningtobeast.appspot.com",
  messagingSenderId: "936131031896",
  appId: "1:936131031896:web:83e85df80fa4307df66b2d"
});

export const db = firebaseApp.firestore();